export const ModoBarra = {
  leitura: "leitura",
  edicao: "edicao",
  insercao: "insercao",
  edicaoregistro: "edicaoregistro",
  novoregistro: "novoregistro",
  acessoSup: "acessoSup",
} as const;

export type ModoBarra = keyof typeof ModoBarra;

export const labelGrid = {
  cod: 'Código',
  codAgente: 'Código Agente',
  nome: 'Razão Social',
  nomeEmpresa: 'Nome Empresa',
  email: 'Email',
  ativo: 'Ativo',
  cnpjCpf: 'CNPJ/CPF',
  logradouro: 'Logradouro',
  bairro: 'Bairro',
  fone: 'Telefone',
  opcoes: 'Opções',
  status: 'Status',
  pedido: 'Pedido',
  pedidoOdin: 'Ped.Odin',
  total: 'Total',
  lancamento: 'Lançamento',
  descricao: 'Descrição',
  adicionar: 'Adicionar',
  excluir: 'Excluir',
  unidade: 'Un',
  quantidade: 'Qtd',
  valor: 'Valor',
  percIpi: '% IPI',
  valorIpi: 'Valor IPI',
  apikey: 'ApiKey',
  usuarios: 'Usuários Ativos',
  nomeFantasia: 'Nome Fantasia',
  nomeCidade: 'Cidade'
}